import { render, staticRenderFns } from "./ExpenseTypeList.vue?vue&type=template&id=3ae5b472&"
import script from "./ExpenseTypeList.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports